import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InlineSVGModule } from "ng-inline-svg";
import { DropdownComponent } from './dropdown.component';
import { ndMenuModule } from 'nd-gui/menu';
import { ndInputModule } from 'nd-gui/input';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    InlineSVGModule.forRoot(),
    ndMenuModule,
    ndInputModule
  ],
  declarations: [DropdownComponent],
  exports: [DropdownComponent]
})
export class ndDropdownModule { }
